import type { SessionStatus } from "./types";

/** Build a Slack deep-link URL from channel ID and thread timestamp. */
export const buildSlackUrl = (channelId: string, threadTs: string): string => {
  const tsWithoutDot = threadTs.replace(".", "");
  return `https://altimateai.slack.com/archives/${channelId}/p${tsWithoutDot}`;
};

export const formatTime = (iso: string) => {
  return new Date(iso).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatDate = (iso: string) => {
  return new Date(iso).toLocaleDateString([], {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/** Returns valid next statuses for a given current status. */
export const getTransitions = (
  current: SessionStatus
): { label: string; status: SessionStatus }[] => {
  switch (current) {
    case "active":
      return [
        { label: "Complete", status: "completed" },
        { label: "Archive", status: "archived" },
        { label: "Cancel", status: "cancelled" },
      ];
    case "completed":
      return [
        { label: "Reopen", status: "active" },
        { label: "Archive", status: "archived" },
      ];
    case "archived":
      return [{ label: "Unarchive", status: "active" }];
    case "cancelled":
      return [{ label: "Reopen", status: "active" }];
    default:
      return [];
  }
};

export const statusStyleMap: Record<SessionStatus, string> = {
  active: "online",
  completed: "offline",
  archived: "offline",
  cancelled: "error",
};
